const setBringOnline = async ({
    worldContract,
    smartObjectId
  }: {
    worldContract: any;
    smartObjectId: string;
  }): Promise<string | undefined> => {
    let txHash;
  
    txHash = await worldContract.write.eveworld__bringOnline([smartObjectId]);

    return txHash;
  };
  
  export default setBringOnline;
  